
import { z } from "zod";
import { CustomFormFieldValidation } from "@shared/types";

interface CustomValidations {
  cpf: CustomFormFieldValidation;
}

export const editUserSchema = () => {
  return z
    .object({
      full_name: z.string().min(1),
      email: z.string().email().min(1),
      cpf: z.string().optional(),
      vandi_customer_id: z.number().optional().nullable(),
      active_agreement: z.number().optional().nullable(),
      user_pdv: z.number().optional().nullable(),
      agreement_staff: z.any().optional().nullable(),
      is_admin: z.boolean().optional(),
      is_tester: z.boolean().optional(),
      agreement_superuser: z.boolean().optional(),
      image: z.any().optional(),
    })
};

export type EditUserFormValues = z.infer<
  ReturnType<typeof editUserSchema>
>;
